import React from 'react';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
import { Section, CTAButton } from './Shared';
export const EmotionalClose = () => {
  return <Section className="max-w-4xl" data-id="element-37">
      <div className="glass-panel p-6 md:p-12 rounded-3xl text-center bg-white/90 border-brand-pink/30 shadow-lg relative overflow-hidden" data-id="element-38">
        <div className="absolute top-0 left-0 w-24 h-24 bg-brand-pink/10 rounded-br-full -z-10" data-id="element-39"></div>
        <div className="absolute bottom-0 right-0 w-24 h-24 bg-brand-gold/10 rounded-tl-full -z-10" data-id="element-40"></div>

        <h2 className="text-2xl md:text-4xl font-display font-bold mb-8 text-brand-pinkDark leading-tight" data-id="element-41">
          Hay dos versiones de vos en este momento.
        </h2>

        <div className="space-y-5 text-base md:text-lg text-brand-text/80 mb-10 max-w-2xl mx-auto" data-id="element-42">
          <p data-id="element-43">
            Una que cierra esta página y mañana se despierta con el mismo peso,
            sin saber qué hacer con ese dolor que no tiene a dónde ir.
          </p>
          <p className="font-medium text-brand-pink" data-id="element-44">
            Y otra que decide que hoy es el día en que empieza a transformar el
            dolor en paz.
          </p>
          <p className="font-serif italic text-lg md:text-xl text-brand-goldDark" data-id="element-45">
            No te pedimos que la olvides.
            <br data-id="element-46" />
            Te invitamos a aprender a llevarla de una manera nueva.
          </p>
        </div>

        <h3 className="text-xl md:text-3xl font-display font-bold mb-8 text-brand-pinkDark" data-id="element-47">
          ¿ESTÁS LISTA/O PARA EMPEZAR?
        </h3>

        <div className="mb-10 max-w-md mx-auto" data-id="element-48">
          <div className="glass-panel rounded-2xl p-6 md:p-7 border-2 border-brand-pink bg-white/95 text-center flex flex-col relative shadow-[0_10px_30px_rgba(219,39,119,0.18)]" data-id="element-49">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-dark text-[10px] md:text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap" data-id="element-50">
              ⭐ ACOMPAÑAMIENTO COMPLETO
            </div>
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-pink mb-1 mt-2" data-id="element-51">
              🌿 SANTUARIO DIGITAL: MAMÁ SIGUE AQUÍ
            </h4>
            <div className="text-3xl md:text-4xl font-bold text-brand-pink mb-3" data-id="element-52">
              $19.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-53">
              1 Tomo Principal + 3 Bonus · Atravesá el duelo con contención
              espiritual, herramientas concretas y paz interior desde hoy.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5" variant="pink" href="https://santuario-digital-mama-sigue-aqui.impultienda.ar/checkout/front" data-id="element-54">
              🌿 → LO QUIERO — $19.990
            </CTAButton>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-brand-muted mb-8" data-id="element-55">
          <div className="flex items-center" data-id="element-56">
            <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-57" /> Pago 100%
            seguro
          </div>
          <div className="flex items-center" data-id="element-58">
            <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-59" /> Acceso en 5
            minutos
          </div>
          <div className="flex items-center" data-id="element-60">
            <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-61" /> Garantía 7
            días
          </div>
          <div className="flex items-center" data-id="element-62">
            <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-63" /> Mercado
            Pago | Tarjeta | Transferencia
          </div>
        </div>

        <div className="text-sm text-brand-text/70 bg-brand-surfaceLight/60 p-5 md:p-6 rounded-2xl border border-brand-pink/20 space-y-3 text-left md:text-center" data-id="element-64">
          <p data-id="element-65">
            <strong className="text-brand-pinkDark" data-id="element-66">P.D.:</strong> El precio de
            lanzamiento cierra pronto. El mejor momento para empezar a sanar es
            ahora. No porque el dolor desaparezca de un día para el otro, sino
            porque hoy podés tener las herramientas para que deje de cargarse
            solo.
          </p>
        </div>
      </div>
    </Section>;
};